import {Box, IconButton, Paper, Typography} from "@mui/material";
import {Edit} from "@mui/icons-material";
import {COLORS} from "../../ui/Theme";
import {ListDivider} from "../../ui/ListStyles";
import React, {useState} from "react";

const ProfileContainer = ({children, title, icon}) => {
    const [editMode, setEditMode] = useState(false)

    const toggleEditMode = () => {
        setEditMode((prev) => !prev);
    };

    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
            }}
        >
            {/*hero section*/}
            <Box sx={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
            }}>
                {icon}
                <Typography sx={{color: COLORS.BLACK, fontSize: "20px", fontWeight: 400}}>
                    {title}
                </Typography>
                {
                    !editMode && (
                        <IconButton onClick={toggleEditMode}>
                            <Edit sx={{color: COLORS.BLUE, fontSize: "16px"}}/>
                        </IconButton>
                    )
                }
            </Box>
            <ListDivider/>

            {/*content section*/}
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}>
                {React.Children.map(children, (child) =>
                    React.isValidElement(child)
                        ? React.cloneElement(child, {editMode, setEditMode})
                        : child
                )}
            </Box>
        </Paper>
    );
};

export default ProfileContainer;